import React, { useState } from 'react';
import './Portfolio.css';

function IotCard() {
  const [activeSection, setActiveSection] = useState('#about');

  const project = {
    id: 1,
    name: 'Smart Notice Board',
    
    about: 'An effective IoT device for displaying essential information of the college events, announcement & schedule of a particular class, it is developed by BOOST IoT Club, SCSIT DAVV Indore.',
    techStackData: ['ESP32', 'MQTT', 'Google Firebase', 'Arduino'],
    imageUrl: 'https://boost-iot.vercel.app/images/mainHome-img.png',
  };

  const handleButtonClick = (section) => {
    setActiveSection(section);
  };

  return (
    <div className="container5">
      <div className="card" data-state={activeSection}>
      <div className="card-header">
        <div style={{ backgroundImage: `url('${project.imageUrl}')` }} className="card-cover"></div>
        <h1 className="card-fullname">{project.name}</h1>
      </div>
      <div className={`card-section ${activeSection === '#about' ? 'is-active' : ''}`} id="about">
        <div className="card-content">
          <div className="card-subtitle">Description</div>
          <div className="card-desc-container">
            <p className="card-desc">{project.about}</p>
          </div>
        </div>
      </div>
      <div
        className={`card-section ${activeSection === '#experience' ? 'is-active' : ''}`}
        id="experience"
      >
        <div className="card-content">
          <div className="card-subtitle">Tech Stack</div>
          <div className="card-tech-stack">
            {project.techStackData.map((tech, techIndex) => (
              <div
                key={techIndex}
                className={`card-tech-item ${activeSection === '#experience' ? 'is-active' : ''}`}
                onClick={() => handleButtonClick('#experience')}
              >
                {tech}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={`card-section ${activeSection === '#contact' ? 'is-active' : ''}`} id="contact">
        <div className="card-content">
          <div className="card-subtitle">CONTACT</div>
          <div className="card-contact-wrapper">
            <div className="card-contact">
              {project.liveLink && (
                <a href={project.liveLink} target="_blank" rel="noopener noreferrer" className="live-button">
                  Live
                </a>
              )}
              {project.liveLink && project.githubLink && <span className="button-separator"></span>}
              {project.githubLink && (
                <a href={project.githubLink} target="_blank" rel="noopener noreferrer" className="github-button">
                  Github
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="card-buttons">
        <button
          onClick={() => handleButtonClick('#about')}
          className={activeSection === '#about' ? 'is-active' : ''}
        >
          ABOUT
        </button>
        <button
          onClick={() => handleButtonClick('#experience')}
          className={activeSection === '#experience' ? 'is-active' : ''}
        >
          Tech Stack
        </button>
        {/* <button
          onClick={() => handleButtonClick('#contact')}
          className={activeSection === '#contact' ? 'is-active' : ''}
        >
          Link
        </button> */}
      </div>
    </div>
    </div>
  );
}

export default IotCard;
